<ion-header class="ion-no-border chat-header-anim" *ngIf="conversationId">
  <ion-toolbar mode="md" [class]="isWeb ? 'web-toolbar' : ''">
    <div class="flex items-end px-4 pb-4 min-h-[70px]">
      <div>
        <ion-button mode="ios" fill="clear" (click)="goBack()" size="small" class="h-fit" *ngIf="!isWeb || isMobile">
          <ion-icon slot="icon-only" class="text-lg" [color]="isMobile ? 'secondary' : 'light'"
            src="../../../../assets/svg/arrowLeft.svg" />
        </ion-button>
      </div>
      <div class="flex gap-4 ml-3 cursor-pointer flex-1" *ngIf="user && !hideUserInfo" (click)="navigate('/user-profile/' + user.id)">
        <div class="h-[38px] w-[38px] rounded-[5px] !bg-cover !bg-center" [ngStyle]="{
            background: user.avatar
              ? 'url(' + user.avatar + ')'
              : 'url(assets/images/team-profile-placeholder.jpg)'
          }"></div>
        <div class="flex flex-col">
          <ion-label class="text-sm font-medium" [class]="isWeb ? 'text-[#294D8F]' : 'text-white'">{{ user.name
            }}</ion-label>
          <ion-label class="text-[11px] font-light" [class]="isWeb ? 'text-[#294D8F]' : 'text-white'">{{
            translateConfigService.getItemTranslated("PROFILE.VIEW_PROFILE")
            }}</ion-label>
        </div>
      </div>
      <!-- Botón de opciones - Solo aparece cuando hay usuario -->
      <div class="flex items-end" *ngIf="user && !hideUserInfo">
        <ion-button mode="ios" fill="clear" size="small" class="h-fit options-button" [color]="!isWeb ? 'light' : 'secondary'"
          (click)="toggleOptionsPopover($event)">
          <ion-icon class="text-2xl" name="ellipsis-vertical" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-toolbar>
  <!-- Exchange flow banner moved here so it scrolls with the header area visually below the profile -->
  <div *ngIf="conversationId && premiumChatUnlocked" class="px-3 w-full exchange-banner-anim" [ngClass]="{
      'bg-[var(--ion-color-secondary)]': exchangeStatus?.status === 'closed',
      'validatedContainer': exchangeStatus?.status === 'closed' && !isWeb,
      'bg-white': exchangeStatus?.status !== 'closed',
      'justify-items-center': exchangeStatus?.status === 'closed',
      'justify-items-start': exchangeStatus?.status !== 'closed',
    }">
    <div class="flex flex-col gap-3 w-full">
      <div class="exchange-status-wrapper w-full">
        <ion-label class="text-[0.7rem] w-full py-2 text-[var(--ion-color-primary)] flex flex-row justify-between">
          @if(!exchangeStatus){
          <div class="flex items-center gap-2">
            <ion-spinner name="crescent" color="secondary" class="w-4 h-4" aria-label="Cargando"></ion-spinner>
            <ion-label class="text-[11px] font-light" [class]="isWeb ? 'text-[#294D8F]' : 'text-white'">
              {{ 'COMMON.LOADING' | translate }}
            </ion-label>
          </div>
          } @else if(exchangeStatus?.status !== 'closed'){

          <div class="flex items-center">
            {{ "CHAT.EXCHANGE_STATUS" | translate }}:
            <strong class="py-4" [ngClass]="{
                'status-none': exchangeStatus?.status === 'none',
                'status-code-generated':
                  exchangeStatus?.status === 'code_generated'
              }">
              {{
              exchangeStatus?.status === "code_generated"
              ? ("CHAT.STATUS_CODE_GENERATED" | translate)
              : exchangeStatus?.status === "none"
              ? ("CHAT.STATUS_NONE" | translate)
              : exchangeStatus?.status || "—"
              }}
            </strong>
          </div>

          <button type="button" *ngIf="!(!isReceptor && exchangeStatus?.status === 'none')"
            class="validate-btn ml-3 py-2 px-3 text-[0.58rem] leading-tight"
            (click)="!isReceptor ? openValidationDialog() : startValidationFlow()">
            @if(isReceptor && exchangeStatus?.status !== 'code_generated'){
            {{ "CHAT.GENERATE_CONFIRMATION_CODE" | translate }}
            } @if(!isReceptor && exchangeStatus?.status === 'code_generated'){
            {{ "CHAT.VALIDATE_TRANSACTION" | translate }}
            } @if(exchangeStatus?.status === 'code_generated' && isReceptor){
            {{ "CHAT.CODE_LABEL" | translate }}
            <span class="exchange-code cursor-pointer" (click)="openCodeDialog()" appLongPress
              (longPress)="copyValidationCode()">{{ exchangeStatus?.codeMasked }}</span>
            }
          </button>
          }@else{
          <span class="text-white flex my-4 w-full justify-center items-center gap-2">
            <span class="transaction-text">{{
              "CHAT.TRANSACTION_VALIDATED" | translate
              }}</span>
            <span class="ml-2 h-6 w-6 rounded-full bg-white flex items-center justify-center">
              <ion-icon name="checkmark" color="secondary" class="font-weight-bold"></ion-icon>
            </span>
          </span>
          }
        </ion-label>
      </div>
    </div>

    <!-- Full-width divider at the bottom of the header -->
    <div class="chat-header-divider" aria-hidden="true"></div>
  </div>

</ion-header>

<!-- Popover de opciones -->
<ion-popover [isOpen]="showOptionsPopover" (didDismiss)="showOptionsPopover = false" [event]="popoverEvent"
  arrow="false" dismissOnSelect="true" mode="ios" alignment="start" side="bottom" class="chat-options-popover">
  <ng-template>
    <ion-content class="ion-padding" scroll-y="false" style="padding-bottom: 15px !important">
      <div class="flex flex-col gap-3">
        <div *ngIf="canRequestRefund" class="flex items-center gap-2 pb-2 cursor-pointer"
          (click)="report()">
          <ion-icon src="../../../../assets/svg/alert.svg" color="secondary"></ion-icon>
          <ion-label color="secondary" class="text-[11px] uppercase pb-1">
            {{ translateConfigService.getItemTranslated("CHAT.REQUEST_REFUND") }}
          </ion-label>
        </div>
        <div class="flex items-center gap-2 pb-2 cursor-pointer" (click)="navigate('/report-user', { queryParams: { id: user?.id } })">
          <ion-icon name="megaphone-outline" color="secondary"></ion-icon>
          <ion-label color="secondary" class="text-[11px] uppercase pb-1">
            {{ translateConfigService.getItemTranslated('USER_PROFILE.REPORT_USER') }}
          </ion-label>
        </div>
        <div class="flex items-center gap-2 pb-2 cursor-pointer" (click)="openBlockDialog()">
          <ion-icon name="hand-left-outline" color="secondary"></ion-icon>
          <ion-label color="secondary" class="text-[11px] uppercase pb-1">
            {{ translateConfigService.getItemTranslated('USER_PROFILE.BLOCK_USER') }}
          </ion-label>
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-popover>

<!-- Modal dialogs (kept outside the conversationId-guard to avoid being destroyed while open) -->
<app-dialog [show]="show" type="confirm" (toggle)="show = false" (confirm)="requestRefund()">
  <ion-label class="text-[13px] mt-4 text-[#131C4F]">
    {{ "CHAT.CONFIRM_REFUND_REQUEST" | translate }}
  </ion-label>
</app-dialog>

<!-- Block user dialog (step 1 confirm) -->
<app-dialog [show]="showBlockConfirm" type="confirm" (toggle)="cancelBlock()" (confirm)="proceedBlock()">
  <ion-label class="text-[13px] mt-4 text-[#131C4F]">
    {{ translateConfigService.getItemTranslated('USER_PROFILE.CONFIRM_BLOCK') }}
  </ion-label>
</app-dialog>

<!-- Validation dialog (moved out) -->
<app-dialog [show]="showValidationDialog" type="accept" (toggle)="showValidationDialog = false"
  (confirm)="confirmValidation()" [buttonText]="'CHAT.VALIDATE_BUTTON' | translate" [close]="true">
  <div class="flex flex-col w-full">
    <ion-label class="text-[13px] mt-2 text-[#131C4F]">{{
      "CHAT.VALIDATION_PROMPT" | translate
      }}</ion-label>
    <ion-item lines="none" class="validation-item mt-2">
      <ion-input maxlength="6" [(ngModel)]="exchangeCodeInput" placeholder="xxxxxx"></ion-input>
    </ion-item>
  </div>
</app-dialog>

<app-dialog [show]="showGenerateCodeConfirmDialog" type="accept"
  (toggle)="closeGenerateCodeDialog()"
  (confirm)="confirmGenerateCode()"
  [buttonText]="'CHAT.GENERATE_CODE_NOW' | translate"
  [close]="true">
  <ion-label class="text-[13px] mt-4 text-[#131C4F]">
    {{ 'CHAT.GENERATE_CONFIRMATION_INFO' | translate }}
  </ion-label>
</app-dialog>

<!-- Blocked success dialog -->
<app-dialog [show]="showBlockSuccess" type="accept" (toggle)="closeBlockSuccess()" [close]="true"
  (confirm)="confirmBlockSuccess()" [buttonText]="'COMMON.OK' | translate">
  <ion-label class="text-[13px] mt-4 text-[#131C4F]">
    <b>{{ translateConfigService.getItemTranslated('USER_PROFILE.USER_BLOCKED_TITLE') }}</b>
    {{ translateConfigService.getItemTranslated('USER_PROFILE.USER_BLOCKED_MESSAGE') }}
  </ion-label>
</app-dialog>

<!-- Dialogo para mostrar el código al receptor -->
<!-- Reemplazado app-dialog por modal básico personalizado -->
<div *ngIf="showCodeDialog" class="code-dialog-backdrop" (click)="closeCodeDialog()">
  <div class="code-dialog-container" (click)="$event.stopPropagation()">
    <div class="code-dialog-text" [innerHTML]="codeDialogInfoSafe"></div>
    <div class="code-preview-band light w-full my-3 flex items-center justify-center" appLongPress
      (longPress)="copyValidationCode()">
      <span class="code-preview-value alt">{{
        exchangeStatus?.codeMasked
        }}</span>
    </div>
    <button type="button" class="code-dialog-btn" (click)="closeCodeDialog()">
      {{ "DIALOG.UNDERSTOOD" | translate }}
    </button>
  </div>
</div>